var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingIconFilledSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "#FFF3C8",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39085 4V4.00801V4.80921C10.1512 5.02554 11.3983 6.62394 11.1818 8.38257C10.9973 9.84076 9.85046 10.9985 8.39085 11.1708V11.972C10.5963 11.7516 12.2003 9.7967 11.9797 7.59339C11.7993 5.69054 10.2875 4.18828 8.39085 4ZM7.58887 4.01202C6.80694 4.08813 6.0611 4.38858 5.45159 4.89334L6.02501 5.48623C6.47412 5.12569 7.01545 4.89334 7.58887 4.81322V4.01202ZM4.88619 5.45819C4.38094 6.0671 4.0802 6.80821 4 7.59339H4.80198C4.87817 7.02454 5.10273 6.48373 5.45961 6.03105L4.88619 5.45819ZM9.39333 6.59189L7.4365 8.54682L6.58639 7.69755L6.16134 8.12218L7.4365 9.39609L9.81838 7.01653L9.39333 6.59189ZM4.00401 8.39459C4.08421 9.17977 4.39297 9.92088 4.8902 10.5298L5.45961 9.95694C5.10674 9.50426 4.87817 8.96345 4.80599 8.39459H4.00401ZM6.02501 10.5458L5.45159 11.0946C6.05709 11.5994 6.80293 11.9159 7.58887 12V11.1988C7.01946 11.1267 6.47813 10.8983 6.02501 10.5458Z",
    fill: "#E48900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIconFilledSmall);
export default __webpack_public_path__ + "static/media/PendingIconFilledSmall.aa35673bcb463fcceaf37f591a756dce.svg";
export { ForwardRef as ReactComponent };